import { Component, OnInit } from '@angular/core';
import {child} from '../../interfaces/child.interface';
import {SuiModal, ComponentModalConfig, ModalSize} from "ng2-semantic-ui"

interface IChildModalContext {
    title:string;
    children: child[];
}

declare var $: any;

@Component({
  selector: 'modal-confirm',
  templateUrl: './childModal.component.html',
  styleUrls: ['./childModal.component.css']
})
export class ChildModalComponent {
  children: child[] = [];
  selectedChild: child;
  selectedIndex: number;
  constructor(public modal:SuiModal<IChildModalContext, child, void>) {

  }

  selectChild(child: child, i):void {
    console.log("selected child " + child.name);
    this.selectedChild = child;
    this.selectedIndex = i;
  }
}

export class ChildModal extends ComponentModalConfig<IChildModalContext, child, void> {
  constructor(title:string, children:child[], size = ModalSize.Small) {
      super(ChildModalComponent, { title, children });

      this.isClosable = false;
      this.transitionDuration = 200;
      this.size = size;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/childModal/childModal.component.ts